(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-1"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    

(() => {

  const headerElement = document.querySelector('.shopify-section--header');

  if (!headerElement) return;

  const headerWrapper = headerElement.querySelector('.header_wrapper');

  if (!headerWrapper) return;

  let resizeFrame;

  const updateHeaderHeight = () => {

    cancelAnimationFrame(resizeFrame);

    resizeFrame = requestAnimationFrame(() => {

      const headerHeight = headerElement.offsetHeight;
      const headerHeightWithoutBottomNav = headerWrapper.offsetHeight;

      document.documentElement.style.setProperty(
        '--header-height',
        `${headerHeight}px`
      );

      document.documentElement.style.setProperty(
        '--header-height-without-bottom-nav',
        `${headerHeightWithoutBottomNav}px`
      );

    });

  };

  updateHeaderHeight();

  if ('ResizeObserver' in window) {

    const headerObserver = new ResizeObserver(updateHeaderHeight);

    headerObserver.observe(headerElement);
    headerObserver.observe(headerWrapper);

  }

  window.addEventListener(
    'resize',
    updateHeaderHeight,
    { passive: true }
  );

  window.addEventListener(
    'load',
    updateHeaderHeight,
    { once: true }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-3"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();
})();
